<div class="basket-error-modal">
  <nx-ng-modal-header
    [title]="'basket_modal_title' | i18next"
  ></nx-ng-modal-header>
  <mat-dialog-content class="top">
    <ng-container>
      <nx-ng-basket-item [errorText]="errorText"></nx-ng-basket-item>
    </ng-container>
  </mat-dialog-content>
  <div mat-dialog-actions class="bottom">
    <ng-container>
      <div class="btn-wrapper">
        <button
          mat-dialog-close
          type="button"
          class="closeBtn"
          aria-label="Close dialog"
          (click)="handleTryAgain()"
          #closeBtn
        >
          {{ retryBtnText | i18next }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
